import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseAuditSearch } from "@/features/administration";
import { AuditPage } from "@/features/administration/pages";
import { ProblemError } from "@/shared/api/problem";
import { strictSearch } from "@/shared/lib/search";

/** v1's log of what staff did holds names and replaced values: hg-order gives it to a superadmin alone. */
export const Route = createFileRoute("/_app/settings/audit")({
  beforeLoad: ({ context }) => {
    if (context.role !== "superadmin") {
      throw new ProblemError({ status: 403, code: "forbidden", title: "Forbidden" });
    }
  },
  validateSearch: strictSearch(parseAuditSearch),
  component: Audit,
});

function Audit() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <AuditPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(entry) =>
        router.buildLocation({ to: "/settings/audit", search: { ...search, entry: entry.id } }).href
      }
    />
  );
}
